import * as React             from 'react'
import Button                 from '@mui/material/Button'
import TextField              from '@mui/material/TextField'
import Dialog                 from '@mui/material/Dialog'
import DialogActions          from '@mui/material/DialogActions'
import DialogContent          from '@mui/material/DialogContent'
import DialogContentText      from '@mui/material/DialogContentText'
import DialogTitle            from '@mui/material/DialogTitle'
import PropTypes              from 'prop-types'
import { useTranslation }     from 'react-i18next'
import { DateTime, Duration } from 'luxon'
import { Alert }              from '@mui/material'
import { useApi }             from '../utils/api'
import { useSnackbar }        from 'notistack'
import Consts                 from '../Consts'
import { useContext }         from 'react'
import { AppContext }         from '../App'

export default function ScheduleChangeDialog({ getFormData, model, modelId, onResult }) {

 const api = useApi()
 const { user } = useContext(AppContext)
 const { t } = useTranslation()
 const { enqueueSnackbar } = useSnackbar()
 const [open, setOpen] = React.useState(false)
 const [error, setError] = React.useState(null)
 const [date, setDate] = React.useState(DateTime.now().plus(Duration.fromObject({ days: 1 })).toFormat('yyyy-MM-dd'))

 const handleClickOpen = () => {
  setOpen(true)
 }

 const handleClose = () => {
  setOpen(false)
 }

 const onConfirm = async () => {
  setError(() => null)
  if (DateTime.fromFormat(date, 'yyyy-MM-dd').startOf('day') < DateTime.now().startOf('day')) {
   setError(() => t('Scheduled time must be in future'))
   return
  }
  let data = getFormData()
  data.scheduled = date
  try {
   if (model === Consts.ScheduleChange.modelService) {
    await api.scheduleChange.service.save(modelId, data)
   } else if (model === Consts.ScheduleChange.modelServiceOperator) {
    await api.scheduleChange.serviceOperator.save(modelId, data)
   } else {
    console.error(`${model} not supported`)
    return
   }
   onResult(true)
   enqueueSnackbar(t('Change scheduled'), {
    variant: 'success'
   })
   handleClose()
  } catch (e) {
   onResult(false)
   enqueueSnackbar(t('Failed to schedule change'), {
    variant: 'error'
   })
  }
 }

 return (
   <React.Fragment>
    <Button type={'button'} color={'secondary'} sx={{ ml: 2 }} variant="outlined" disabled={user?.readonly} onClick={(e) => {
     e.preventDefault()
     handleClickOpen()
    }}>
     {t('Schedule change')}
    </Button>
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'sm'}
      onClose={handleClose}
    >
     <DialogTitle>{t('Schedule change')}</DialogTitle>
     <DialogContent>
      <DialogContentText>
       {t('scheduleChangeDesc')}
      </DialogContentText>
      <TextField
        autoFocus
        required
        margin="dense"
        id="date"
        name="date"
        label={t('Change active from')}
        type="date"
        fullWidth
        variant="standard"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />
      {error && <Alert sx={{ mt: 2 }} severity="error">{error}</Alert>}
     </DialogContent>
     <DialogActions>
      <Button color={'error'} onClick={handleClose}>{t('Cancel')}</Button>
      <Button onClick={onConfirm}>{t('Confirm')}</Button>
     </DialogActions>
    </Dialog>
   </React.Fragment>
 )
}

ScheduleChangeDialog.propTypes = {
 getFormData: PropTypes.func.isRequired,
 model: PropTypes.oneOf([Consts.ScheduleChange.modelService, Consts.ScheduleChange.modelServiceOperator]).isRequired,
 modelId: PropTypes.number.isRequired,
}